export default __webpack_public_path__ + "static/media/imageUpload.1b847c57.svg";